import React from "react";
import "./app.css";
import Layout from "./components/layout";
import Router from "./components/routes";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div className="container">
      <ScrollToTop />
      <Layout>
        <Router />
      </Layout>
    </div>
  );
};

export default App;
